import React from 'react';
import { connect } from 'react-redux';
import { REDUCER_NAME, toggleShowInfoUser } from '../../../sidebar/reducer';
import InfoUser from './InforUser';
import './infoUser.scss';

class AccountInfoPopup extends React.Component {
  render() {
    const { isShowInfoUser, toggleShowInfoUser } = this.props;
    return (
      <div className="user-info-setting">
        {isShowInfoUser && (
          <div className="popup-user-info-setting">
            <InfoUser
              isShow={isShowInfoUser}
              toggleShowInfoUser={toggleShowInfoUser}
            />
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    isShowInfoUser: state[REDUCER_NAME].userInfo.isShowInfoUser,
  };
};

const mapDispatchToProps = {
  toggleShowInfoUser,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AccountInfoPopup);
